<div class="inventory-locations-container">
	<div class="content">
		<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"></app-loading-state>
		<ng-template #loadedContent>
			<ng-container *ngIf="userHasAccess; else noAccess">
				<div class="inventory-container">
					<div class="content">
						<ng-container *ngIf="isMobileSize; else desktopSize">
							<app-mobile-inventory-locations-table
								[isLoading]="locationsLoading"
								[locationItems]="inventoryLocations"
								[showArchived$]="showArchived$"
								(inventoryLocationEdit)="onInventoryLocationEdit($event)"
								(inventoryLocationViewItems)="openViewInventoryItemsOffcanvas($event)"
								(inventoryLocationArchive)="onInventoryLocationArchive($event)"
								(inventoryLocationUnarchive)="onInventoryLocationUnarchive($event)"
								(addNewEvent)="openAddInventoryLocationOffcanvas()"
							></app-mobile-inventory-locations-table>
						</ng-container>
						<ng-template #desktopSize>
							<app-desktop-inventory-locations-table
								[isLoading]="locationsLoading"
								[locationItems]="inventoryLocations"
								[showArchived$]="showArchived$"
								(inventoryLocationEdit)="onInventoryLocationEdit($event)"
								(inventoryLocationViewItems)="openViewInventoryItemsOffcanvas($event)"
								(inventoryLocationArchive)="onInventoryLocationArchive($event)"
								(inventoryLocationUnarchive)="onInventoryLocationUnarchive($event)"
								(addNewEvent)="openAddInventoryLocationOffcanvas()"
							></app-desktop-inventory-locations-table>
						</ng-template>
					</div>
				</div>
			</ng-container>

			<ng-template #noAccess>
				<app-unauthorised-banner
					headingText="It looks like you do not have access to this organisation or do not have the required access level."
				></app-unauthorised-banner>
			</ng-template>
		</ng-template>
	</div>
</div>
